import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import api from '../lib/api'

export default function Dashboard() {
  const [data,    setData]    = useState(null)
  const [loading, setLoading] = useState(true)
  const [error,   setError]   = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    api.get('/dashboard')
      .then(res => setData(res.data))
      .catch(err => setError(err.response?.data?.message ?? 'Error al cargar el dashboard.'))
      .finally(() => setLoading(false))
  }, [])

  if (loading) return (
    <div className="content">
      <div className="kpi-grid">
        {[1,2,3,4].map(i => (
          <div key={i} className="kpi">
            <div className="skeleton" style={{ height: '14px', width: '60%', marginBottom: '10px' }} />
            <div className="skeleton" style={{ height: '30px', width: '40%' }} />
          </div>
        ))}
      </div>
    </div>
  )

  if (error) return (
    <div className="content">
      <div className="error-banner">⚠ {error}</div>
    </div>
  )

  return (
    <>
      <div className="topbar">
        <div className="breadcrumb"><strong>Dashboard</strong> — Vista global</div>
        <div className="topbar-actions">
          <button className="btn btn-primary" onClick={() => navigate('/wizard')}>+ Nuevo cliente</button>
        </div>
      </div>

      <div className="content">
        <div className="kpi-grid">
          <div className="kpi">
            <div className="kpi-header">
              <span className="kpi-label">Tenants registrados</span>
              <div className="kpi-icon blue">🏢</div>
            </div>
            <div className="kpi-value">{data.total_tenants}</div>
            <div className="kpi-sub">{data.activos} activos · {data.inactivos} inactivos</div>
          </div>

          <div className="kpi">
            <div className="kpi-header">
              <span className="kpi-label">En producción</span>
              <div className="kpi-icon green">🟢</div>
            </div>
            <div className="kpi-value">{data.en_produccion}</div>
            <div className="kpi-sub">{data.en_pruebas} en ambiente de pruebas</div>
          </div>

          <div className="kpi">
            <div className="kpi-header">
              <span className="kpi-label">Inactivos</span>
              <div className="kpi-icon red">⛔</div>
            </div>
            <div className="kpi-value" style={{ color: data.inactivos > 0 ? 'var(--red)' : 'inherit' }}>
              {data.inactivos}
            </div>
            <div className="kpi-sub">
              {data.inactivos > 0 ? 'Requieren revisión' : 'Todos operativos'}
            </div>
          </div>

          <div className="kpi">
            <div className="kpi-header">
              <span className="kpi-label">Nuevos este mes</span>
              <div className="kpi-icon yellow">✨</div>
            </div>
            <div className="kpi-value">{data.nuevos_este_mes}</div>
            <div className="kpi-sub">clientes incorporados</div>
          </div>
        </div>

        <div className="panel" style={{ marginTop: '20px' }}>
          <div className="panel-head">
            Últimos clientes registrados
            <button className="btn btn-ghost btn-sm" onClick={() => navigate('/empresas')}>Ver todos →</button>
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table>
              <thead>
                <tr>
                  <th>Empresa</th>
                  <th>Subdominio</th>
                  <th>NIT</th>
                  <th>Ambiente</th>
                  <th>Estado</th>
                  <th>Registrado</th>
                </tr>
              </thead>
              <tbody>
                {(data.recientes ?? []).length === 0 && (
                  <tr><td colSpan={6} className="empty">Sin tenants registrados</td></tr>
                )}
                {(data.recientes ?? []).map(t => (
                  <tr key={t.id} style={{ cursor: 'pointer' }} onClick={() => navigate(`/empresas/${t.id}`)}>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <div className="t-logo" style={{ background: 'linear-gradient(135deg,#3b4fd8,#6d28d9)' }}>
                          {(t.company_name ?? '').slice(0, 2).toUpperCase()}
                        </div>
                        <span style={{ fontWeight: 600 }}>{t.company_name}</span>
                      </div>
                    </td>
                    <td><span className="mono">{t.subdomain}</span></td>
                    <td><span className="mono">{t.nit}</span></td>
                    <td>
                      {t.ambiente === '01'
                        ? <span className="badge badge-prod">Producción</span>
                        : <span className="badge badge-test">Pruebas</span>}
                    </td>
                    <td>
                      {t.active
                        ? <span className="badge badge-ok">Activo</span>
                        : <span className="badge badge-neutral">Inactivo</span>}
                    </td>
                    <td style={{ color: 'var(--muted)', fontSize: '12px' }}>
                      {new Date(t.created_at).toLocaleDateString('es-SV')}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}
